import React from 'react'
import { useIsAllowedWebsiteHeaderEntity } from 'src/editor/hooks/use-is-allowed-website-header-entity'
import { MenuInterface } from 'src/shared/types/entities/menu'
import { CommonMenuSettings } from './common-menu-settings'

export interface WebsiteMenuSettingsProps {
  entity: MenuInterface
  defaultEntity?: MenuInterface
}

export const WebsiteMenuSettings = ({
  entity,
  defaultEntity,
}: WebsiteMenuSettingsProps) => {
  const isAllowedWebsiteHeaderEntity = useIsAllowedWebsiteHeaderEntity(
    entity.parentId,
    entity.type,
  )

  return (
    <CommonMenuSettings
      entity={entity}
      defaultEntity={defaultEntity}
      isWebsite
      isAllowedWebsiteHeaderEntity={isAllowedWebsiteHeaderEntity}
    />
  )
}
